module.exports = __webpack_public_path__ + "media/src/application/media/svg/user_min-af4ae6cf12cb38a96e2bc91d9f7761e0.svg";